import {
  getTaggedClass,
  OVEntity,
  OVField,
  OVForm,
  OVSearchable,
  OVSidebar, OVTable
} from '@ov-suite/ov-metadata';
import { Recurrence, WeekDay, getNumberWithOrdinal, DayMapper } from '@ov-suite/helpers-shared';
import moment from 'moment';

@OVEntity('WaveConfig', 'warehouselink')
@OVForm([
  ['#Picking Waves'],
  ['waveName'],
  ['#Start'],
  ['startDate'],
  ['startTime'],
  ['endTime'],
  ['#Frequency'],
  ['recurring'],
  ['recurrence'],
  ['description'],
])
@OVSidebar([['id']])
@OVTable<WaveConfig>([
  {
    key: 'waveName',
    title: 'Name',
    type: 'string'
  },
  {
    key: 'createdAt',
    title: 'Date Created',
    type: 'date'
  },
  {
    key: 'recurring',
    title: 'Recurring',
    type: 'string'
  },
  {
    title: 'Wave Date & Time',
    type: 'other',
    keys: ['startDate', 'startTime'],
    action:(wave)=>{
     return `${moment(wave.startDate).format("dddd , MMMM Do")} - ${ moment(wave.startTime, "HH:mm:ss").format("hh:mm") }`;
    }
  },
  {
    title: 'Recurring',
    type: 'other',
    keys: ['recurrence'],
    action: (r)=> {
      const data: Recurrence = JSON.parse(r.recurrence);
      if(data) {
        switch (data.type) {
          case 'daily':
          {
            if(data.repeat === 1) {
              return 'Daily'
            }else {
              return `Every ${getNumberWithOrdinal(data.repeat)} day`
            }
          }
          break;
          case 'weekly':
          {
            if(data.days === 127){
              return "Daily";
            }

            const days: string[] = [];
            Object.entries(DayMapper).forEach(([key, day])=>{
              if((Number(key) | data.days) === data.days){
                days.push(day);
              }
            })

            return `Weekly on ${days.reverse().join(', ')}`;
          }
          break;
          case 'monthly':
          {
           const weekName = getNumberWithOrdinal(data.weekNumber);
           const dayName = getNumberWithOrdinal(data.day);
           const day = (data.weekNumber)? `${weekName} week on ${WeekDay[data.day]}`: `${dayName}`;
            return `Monthly on the ${day}`
          }
          break;
        }
      }

      return r.recurrence;
    }
  },
  {
    title: 'Actions',
    keys: [],
    type: 'buttons',
    disableSorting: true,
    disableFiltering: true,
    buttons: [
      {
        classes: 'btn btn-warning btn-xs ml-1 mr-1',
        action: (item, { ngbModal }) => {
          const modalRef = ngbModal.open(
            getTaggedClass('create-wave-popup', WaveConfig),
            { size: 'md' }
          );
          modalRef.componentInstance.waveConfig = item;
        },
        title: '',
        icon: 'fa fa-clone text-dark'
      },
    ]
  },
])
export class WaveConfig {
  @OVField({
    type: 'string',
    title: 'Unique ID',
    sidebar: true,
    generated: true,
    readonly: true
  })
  id: number;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Wave Name',
    placeholder: 'Required',
    required: true
  })
  waveName: string;

  @OVSearchable()
  @OVField({
    type: 'date',
    title: 'Start Date',
    placeholder: 'Required',
    required: true
  })
  startDate: Date;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Start Date',
    placeholder: 'Required',
    required: true
  })
  startTime: string;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Start Date',
    placeholder: 'Required',
    required: true
  })
  endTime: string;

  @OVSearchable()
  @OVField({
    type: 'date',
    title: 'Created At',
    placeholder: 'Required',
    required: false
  })
  createdAt: Date;

  @OVSearchable()
  @OVField({
    type: 'boolean',
    title: 'Recurring',
    placeholder: 'Required',
    required: false
  })
  recurring: boolean;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Template',
    placeholder: 'Required',
    required: false
  })
  templateName: string;

  @OVField({
    type: 'json',
    title: 'Description',
    required: false,
  })
  recurrence?: string;

  @OVField({
    type: 'string',
    title: 'Description',
    required: false
  })
  description: string;
}
